export enum SfIconsNames {
  AccountInfo = 'account_info',
  AccountScore = 'account_score',
  Account = 'account',
  ActionListComponent = 'action_list_component',
  ActionsAndButtons = 'actions_and_buttons',
  ActivationTarget = 'activation_target',
  Activations = 'activations',
  AdEventAction = 'ad_event_action',
  AdEventCause = 'ad_event_cause',
  AdEventEffect = 'ad_event_effect',
  AdEventFactor = 'ad_event_factor',
  AdEventInfo = 'ad_event_info',
  AdEventOutcome = 'ad_event_outcome',
  AdEventParty = 'ad_event_party',
  Address = 'address',
  AdverseEvent = 'adverse_event',
  AgentHome = 'agent_home',
  AgentSession = 'agent_session',
  Aggregate = 'aggregate',
  AggregationPolicy = 'aggregation_policy',
  AiAcceleratorCard = 'ai_accelerator_card',
  All = 'all',
  Announcement = 'announcement',
  AnswerBest = 'answer_best',
  AnswerPrivate = 'answer_private',
  AnswerPublic = 'answer_public',
  AppFormProductParticipant = 'app_form_product_participant',
  Approval = 'approval',
  AppsAdmin = 'apps_admin',
  Apps = 'apps',
  Article = 'article',
  AssetActionSource = 'asset_action_source',
  AssetAction = 'asset_action',
  AssetAudit = 'asset_audit',
  AssetDowntimePeriod = 'asset_downtime_period',
  AssetHierarchy = 'asset_hierarchy',
  AssetObject = 'asset_object',
  AssetRelationship = 'asset_relationship',
  AssetStatePeriod = 'asset_state_period',
  AssetWarranty = 'asset_warranty',
  AssignedResource = 'assigned_resource',
  Assignment = 'assignment',
  Attach = 'attach',
  AttributeBasedPricing = 'attribute_based_pricing',
  AvatarLoading = 'avatar_loading',
  Avatar = 'avatar',
  BillOfMaterials = 'bill_of_materials',
  Billing = 'billing',
  BotTraining = 'bot_training',
  Bot = 'bot',
  BranchMerge = 'branch_merge',
  Brand = 'brand',
  BudgetAllocation = 'budget_allocation',
  BudgetCategoryValue = 'budget_category_value',
  BudgetPeriod = 'budget_period',
  Budget = 'budget',
  BundleConfig = 'bundle_config',
  BundlePolicy = 'bundle_policy',
  BundlesPricing = 'bundles_pricing',
  BusinessHours = 'business_hours',
  BuyerAccount = 'buyer_account',
  BuyerGroupQualifier = 'buyer_group_qualifier',
  BuyerGroup = 'buyer_group',
  CalculatedDimension = 'calculated_dimension',
  CalculatedInsights = 'calculated_insights',
  CalculatedMeasure = 'calculated_measure',
  Calibration = 'calibration',
  CallCoaching = 'call_coaching',
  CallHistory = 'call_history',
  Call = 'call',
  CampaignMembers = 'campaign_members',
  Campaign = 'campaign',
  Canvas = 'canvas',
  CapacityPlan = 'capacity_plan',
  CareRequestReviewer = 'care_request_reviewer',
  Carousel = 'carousel',
  CodePlayground = 'code_playground',
  CodeSetBundle = 'code_set_bundle',
  CodeSet = 'code_set',
  CollectionVariable = 'collection_variable',
  Collection = 'collection',
  ConnectWallet = 'connect_wallet',
  ConnectedApps = 'connected_apps',
  Constant = 'constant',
  ContactList = 'contact_list',
  ContactRequest = 'contact_request',
  Contact = 'contact',
  ContractLineItem = 'contract_line_item',
  ContractLineOutcomeData = 'contract_line_outcome_data',
  ContractLineOutcome = 'contract_line_outcome',
  ContractPayment = 'contract_payment',
  Contract = 'contract',
  CostModel = 'cost_model',
  CouponCodes = 'coupon_codes',
  CryptoCategoryWalletGroup = 'crypto_category_wallet_group',
  CryptoProductCategoryWalletRole = 'crypto_product_category_wallet_role',
  CryptoTransactionEnvelopeChangeSnapshot = 'crypto_transaction_envelope_change_snapshot',
  CryptoTransactionEnvelopeItem = 'crypto_transaction_envelope_item',
  CryptoTransactionEnvelope = 'crypto_transaction_envelope',
  CryptoTransaction = 'crypto_transaction',
  CryptoWalletGroupItem = 'crypto_wallet_group_item',
  CryptoWalletGroup = 'crypto_wallet_group',
  CryptoWallet = 'crypto_wallet',
  CurrencyInput = 'currency_input',
  CryptoProduct = 'crypto_product',
  Currency = 'currency',
  CustodyChainEntry = 'custody_chain_entry',
  CustodyEntryVerification = 'custody_entry_verification',
  CustodyOverride = 'custody_override',
  CustomComponentTask = 'custom_component_task',
  CustomNotification = 'custom_notification',
  Custom = 'custom',
  Customer360 = 'customer_360',
  CustomerLifecycleAnalytics = 'customer_lifecycle_analytics',
  CustomerPortalUsers = 'customer_portal_users',
  CustomerWorkspace = 'customer_workspace',
  Customer = 'customer',
  Customers = 'customers',
  DashboardComponent = 'dashboard_component',
  DashboardEa = 'dashboard_ea',
  Dashboard = 'dashboard',
  DataCloud = 'data_cloud',
  DataGovernance = 'data_governance',
  DataGraph = 'data_graph',
  DataIntegrationHub = 'data_integration_hub',
  DataLakeObjects = 'data_lake_objects',
  DataMapping = 'data_mapping',
  DataModel = 'data_model',
  DataStreams = 'data_streams',
  DataTransforms = 'data_transforms',
  Datadotcom = 'datadotcom',
  Dataset = 'dataset',
  DatashareTarget = 'datashare_target',
  Datashares = 'datashares',
  DateInput = 'date_input',
  DateTime = 'date_time',
  Decision = 'decision',
  Default = 'default',
  DelegatedAccount = 'delegated_account',
  Device = 'device',
  DigitalVerificationConfigGroup = 'digital_verification_config_group',
  DigitalVerificationConfig = 'digital_verification_config',
  DisclosureAndCompliance = 'disclosure_and_compliance',
  Discounts = 'discounts',
  DiseaseDefinitionCriteria = 'disease_definition_criteria',
  DiseaseInvestigation = 'disease_investigation',
  DiseaseOutbreak = 'disease_outbreak',
  DisplayRichText = 'display_rich_text',
  DisplayText = 'display_text',
  DocumentPreview = 'document_preview',
  DocumentReference = 'document_reference',
  Document = 'document',
  Drafts = 'drafts',
  DurationDownscale = 'duration_downscale',
  DynamicHighlightsPanel = 'dynamic_highlights_panel',
  DynamicRecordChoice = 'dynamic_record_choice',
  EditForm = 'edit_form',
  Education = 'education',
  EinsteinReplies = 'einstein_replies',
  EmailChatter = 'email_chatter',
  Email = 'email',
  EmployeeAsset = 'employee_asset',
  EmployeeContact = 'employee_contact',
  EmployeeJobPosition = 'employee_job_position',
  EmployeeJob = 'employee_job',
  EmployeeOrganization = 'employee_organization',
  Employee = 'employee',
  Empty = 'empty',
  Endorsement = 'endorsement',
  EnrolleeStatus = 'enrollee_status',
  EntitlementPolicy = 'entitlement_policy',
  EntitlementProcess = 'entitlement_process',
  EntitlementTemplate = 'entitlement_template',
  Entitlement = 'entitlement',
  EntityMilestone = 'entity_milestone',
  Entity = 'entity',
  EnvironmentHub = 'environment_hub',
  EvalResult = 'eval_result',
  EventExt = 'event_ext',
  Event = 'event',
  Events = 'events',
  ExpenseReportEntry = 'expense_report_entry',
  ExpenseReport = 'expense_report',
  Expense = 'expense',
  FacilityBed = 'facility_bed',
  Feed = 'feed',
  Feedback = 'feedback',
  FieldSales = 'field_sales',
  File = 'file',
  FilterCriteriaRule = 'filter_criteria_rule',
  FilterCriteria = 'filter_criteria',
  Filter = 'filter',
  FirstNonEmpty = 'first_non_empty',
  Flow = 'flow',
  Folder = 'folder',
  Forecasts = 'forecasts',
  Form = 'form',
  Formula = 'formula',
  FulfillmentOrder = 'fulfillment_order',
  FundingAwardAdjustment = 'funding_award_adjustment',
  FundingRequirement = 'funding_requirement',
  GenericLoading = 'generic_loading',
  GlobalConstant = 'global_constant',
  Goals = 'goals',
  GroupLoading = 'group_loading',
  Groups = 'groups',
  GuidanceCenter = 'guidance_center',
  HeaderDiscounts = 'header_discounts',
  Hierarchy = 'hierarchy',
  HighVelocitySales = 'high_velocity_sales',
  HistoricalAdherence = 'historical_adherence',
  HolidayOperatingHours = 'holiday_operating_hours',
  Home = 'home',
  Household = 'household',
  Identifier = 'identifier',
  Immunization = 'immunization',
  ImpactOutcome = 'impact_outcome',
  ImpactStrategyAssignment = 'impact_strategy_assignment',
  ImpactStrategy = 'impact_strategy',
  Inbox = 'inbox',
  Incident = 'incident',
  IndicatorAssignment = 'indicator_assignment',
  IndicatorDefinition = 'indicator_definition',
  IndicatorPerformancePeriod = 'indicator_performance_period',
  IndicatorResult = 'indicator_result',
  Individual = 'individual',
  Insights = 'insights',
  InstoreLocations = 'instore_locations',
  InvestmentAccount = 'investment_account',
  InvocableAction = 'invocable_action',
  IotContext = 'iot_context',
  IotOrchestrations = 'iot_orchestrations',
  JavascriptButton = 'javascript_button',
  JobFamily = 'job_family',
  JobPosition = 'job_position',
  JobProfile = 'job_profile',
  Kanban = 'kanban',
  KeyDates = 'key_dates',
  Knowledge = 'knowledge',
  Labels = 'labels',
  LeadInsights = 'lead_insights',
  LeadList = 'lead_list',
  Lead = 'lead',
  LearnerProgram = 'learner_program',
  Letterhead = 'letterhead',
  LifeSciences = 'life_sciences',
  LightningComponent = 'lightning_component',
  LightningUsage = 'lightning_usage',
  Link = 'link',
  Linked = 'linked',
  ListEmail = 'list_email',
  ListFee = 'list_fee',
  ListRate = 'list_rate',
  LiveChatVisitor = 'live_chat_visitor',
  LiveChat = 'live_chat',
  LocationPermit = 'location_permit',
  Location = 'location',
  LogACall = 'log_a_call',
  Logging = 'logging',
  Loop = 'loop',
  Macros = 'macros',
  MaintenanceAsset = 'maintenance_asset',
  MaintenancePlan = 'maintenance_plan',
  MaintenanceWorkRule = 'maintenance_work_rule',
  ManualDiscounts = 'manual_discounts',
  MapLineItem = 'map_line_item',
  Market = 'market',
  MarketingActions = 'marketing_actions',
  MedRecRecommendation = 'med_rec_recommendation',
  MedRecStatementRecommendation = 'med_rec_statement_recommendation',
  MedicationAdministration = 'medication_administration',
  MedicationDispense = 'medication_dispense',
  MedicationIngredient = 'medication_ingredient',
  MedicationReconciliation = 'medication_reconciliation',
  MedicationStatement = 'medication_statement',
  Medication = 'medication',
  MemberPeriod = 'member_period',
  Merge = 'merge',
  MessagingConversation = 'messaging_conversation',
  MessagingSession = 'messaging_session',
  MessagingUser = 'messaging_user',
  MetricDefinition = 'metric_definition',
  Metric = 'metric',
  Metrics = 'metrics',
  Mulesoft = 'mulesoft',
  MultiPicklist = 'multi_picklist',
  MultiSelectCheckbox = 'multi_select_checkbox',
  NetworkContract = 'network_contract',
  News = 'news',
  NftSettings = 'nft_settings',
  NftStudio = 'nft_studio',
  NoCodeModel = 'no_code_model',
  Note = 'note',
  NumberInput = 'number_input',
  ObservationComponent = 'observation_component',
  OmniChannel = 'omni_channel',
  OmniSupervisor = 'omni_supervisor',
  OperatingHours = 'operating_hours',
  OperationPlanExecution = 'operation_plan_execution',
  OperationPlanRequest = 'operation_plan_request',
  OperationPlanStepExecution = 'operation_plan_step_execution',
  OperationPlanStep = 'operation_plan_step',
  OperationPlan = 'operation_plan',
  OpportunityContactRole = 'opportunity_contact_role',
  OpportunitySplits = 'opportunity_splits',
  Opportunity = 'opportunity',
  Orchestrator = 'orchestrator',
  OrderItem = 'order_item',
  Orders = 'orders',
  OutcomeActivity = 'outcome_activity',
  Outcome = 'outcome',
  Output = 'output',
  PanelDetail = 'panel_detail',
  PartnerFundAllocation = 'partner_fund_allocation',
  PartnerFundClaim = 'partner_fund_claim',
  PartnerFundRequest = 'partner_fund_request',
  PartnerMarketingBudget = 'partner_marketing_budget',
  Partners = 'partners',
  PartyProfile = 'party_profile',
  Password = 'password',
  PastChat = 'past_chat',
  PathExperiment = 'path_experiment',
  PatientMedicationDosage = 'patient_medication_dosage',
  PatientService = 'patient_service',
  PaymentGateway = 'payment_gateway',
  PeopleScore = 'people_score',
  People = 'people',
  Performance = 'performance',
  PersonAccount = 'person_account',
  PersonLanguage = 'person_language',
  PersonName = 'person_name',
  Photo = 'photo',
  PicklistChoice = 'picklist_choice',
  PicklistType = 'picklist_type',
  Planogram = 'planogram',
  Policy = 'policy',
  Poll = 'poll',
  PortalRolesAndSubordinates = 'portal_roles_and_subordinates',
  PortalRoles = 'portal_roles',
  Portal = 'portal',
  Post = 'post',
  PractitionerRole = 'practitioner_role',
  PrepFlow = 'prep_flow',
  PriceAdjustmentMatrix = 'price_adjustment_matrix',
  PriceAdjustmentSchedule = 'price_adjustment_schedule',
  PriceAdjustmentTier = 'price_adjustment_tier',
  PriceBookEntries = 'price_book_entries',
  PriceBooks = 'price_books',
  PriceSheet = 'price_sheet',
  Pricebook = 'pricebook',
  PricingWorkspace = 'pricing_workspace',
  Problem = 'problem',
  ProcedureDetail = 'procedure_detail',
  ProcedureOutputResolution = 'procedure_output_resolution',
  Procedure = 'procedure',
  ProcessException = 'process_exception',
  Process = 'process',
  ProductConsumedState = 'product_consumed_state',
  ProductConsumed = 'product_consumed',
  ProductItemTransaction = 'product_item_transaction',
  ProductItem = 'product_item',
  ProductQuantityRules = 'product_quantity_rules',
  ProductRequestLineItem = 'product_request_line_item',
  ProductRequest = 'product_request',
  ProductRequired = 'product_required',
  ProductServiceCampaignItem = 'product_service_campaign_item',
  ProductServiceCampaign = 'product_service_campaign',
  ProductTransferState = 'product_transfer_state',
  ProductTransfer = 'product_transfer',
  ProductWarrantyTerm = 'product_warranty_term',
  ProductWorkspace = 'product_workspace',
  Product = 'product',
  Products = 'products',
  ProgramCohortMember = 'program_cohort_member',
  ProgramCohort = 'program_cohort',
  ProgramDetail = 'program_detail',
  ProgramSite = 'program_site',
  ProgramStatus = 'program_status',
  PromotionSegments = 'promotion_segments',
  PromotionTiers = 'promotion_tiers',
  PromotionsWorkspace = 'promotions_workspace',
  Promotions = 'promotions',
  PromptBuilder = 'prompt_builder',
  Prompt = 'prompt',
  PropagationPolicy = 'propagation_policy',
  Proposition = 'proposition',
  Prospect = 'prospect',
  Qualifications = 'qualifications',
  QueryEditor = 'query_editor',
  QuestionBest = 'question_best',
  QuestionFeed = 'question_feed',
  Queue = 'queue',
  QuickText = 'quick_text',
  QuipSheet = 'quip_sheet',
  Quip = 'quip',
  Quotes = 'quotes',
  RadioButton = 'radio_button',
  RateAdjustment = 'rate_adjustment',
  ReadReceipts = 'read_receipts',
  RealTime = 'real_time',
  Recent = 'recent',
  Recipe = 'recipe',
  RecordConsent = 'record_consent',
  RecordCreate = 'record_create',
  RecordDelete = 'record_delete',
  RecordLookup = 'record_lookup',
  RecordSignatureTask = 'record_signature_task',
  RecordUpdate = 'record_update',
  Record = 'record',
  RecycleBin = 'recycle_bin',
  RegisteredModel = 'registered_model',
  RelatedList = 'related_list',
  Relationship = 'relationship',
  Repeaters = 'repeaters',
  Replace = 'replace',
  ReplyText = 'reply_text',
  ReportType = 'report_type',
  Report = 'report',
  ResetPassword = 'reset_password',
  ResourceAbsence = 'resource_absence',
  ResourceCapacity = 'resource_capacity',
  ResourcePreference = 'resource_preference',
  ResourceSkill = 'resource_skill',
  RestrictionPolicy = 'restriction_policy',
  ReturnOrderLineItem = 'return_order_line_item',
  ReturnOrder = 'return_order',
  Reward = 'reward',
  Robot = 'robot',
  RtcPresence = 'rtc_presence',
  SalesCadenceTarget = 'sales_cadence_target',
  SalesCadence = 'sales_cadence',
  SalesChannel = 'sales_channel',
  SalesPath = 'sales_path',
  SalesValue = 'sales_value',
  SalesforceCms = 'salesforce_cms',
  ScanCard = 'scan_card',
  ScheduleObjective = 'schedule_objective',
  SchedulingConstraint = 'scheduling_constraint',
  SchedulingPolicy = 'scheduling_policy',
  SchedulingWorkspaceTerritory = 'scheduling_workspace_territory',
  SchedulingWorkspace = 'scheduling_workspace',
  Screen = 'screen',
  Search = 'search',
  Section = 'section',
  Segments = 'segments',
  SellingModel = 'selling_model',
  SendLog = 'send_log',
  SerializedProductTransaction = 'serialized_product_transaction',
  SerializedProduct = 'serialized_product',
  ServiceAppointmentCapacityUsage = 'service_appointment_capacity_usage',
  ServiceAppointment = 'service_appointment',
  ServiceContract = 'service_contract',
  ServiceCrewMember = 'service_crew_member',
  ServiceCrew = 'service_crew',
  ServiceReport = 'service_report',
  ServiceRequestDetail = 'service_request_detail',
  ServiceRequest = 'service_request',
  ServiceResource = 'service_resource',
  ServiceTerritoryLocation = 'service_territory_location',
  ServiceTerritoryMember = 'service_territory_member',
  ServiceTerritoryPolicy = 'service_territory_policy',
  ServiceTerritory = 'service_territory',
  Settings = 'settings',
  SetupModal = 'setup_modal',
  ShiftPatternEntry = 'shift_pattern_entry',
  ShiftPattern = 'shift_pattern',
  ShiftPreference = 'shift_preference',
  ShiftSchedulingOperation = 'shift_scheduling_operation',
  ShiftTemplate = 'shift_template',
  ShiftType = 'shift_type',
  Shift = 'shift',
  Shipment = 'shipment',
  SkillEntity = 'skill_entity',
  SkillRequirement = 'skill_requirement',
  Skill = 'skill',
  SlackConversations = 'slack_conversations',
  Slack = 'slack',
  Slider = 'slider',
  Sms = 'sms',
  SnippetAlt = 'snippet_alt',
  Snippet = 'snippet',
  Snippets = 'snippets',
  SobjectCollection = 'sobject_collection',
  Sobject = 'sobject',
  Social = 'social',
  Solution = 'solution',
  SortPolicy = 'sort_policy',
  Sort = 'sort',
  Sossession = 'sossession',
  StageCollection = 'stage_collection',
  Stage = 'stage',
  Steps = 'steps',
  StoreGroup = 'store_group',
  Store = 'store',
  Story = 'story',
  Strategy = 'strategy',
  StudyCandidate = 'study_candidate',
  StudyRelated = 'study_related',
  Study = 'study',
  SubMetric = 'sub_metric',
  SummaryLiable = 'summary_liable',
  SummaryUsage = 'summary_usage',
  Survey = 'survey',
  SwarmRequest = 'swarm_request',
  SwarmSession = 'swarm_session',
  SystemAndGlobalVariable = 'system_and_global_variable',
  Table = 'table',
  Tableau = 'tableau',
  Task2 = 'task2',
  Task = 'task',
  TaxPolicy = 'tax_policy',
  TaxRate = 'tax_rate',
  TaxTreatment = 'tax_treatment',
  Taxonomy = 'taxonomy',
  TeamMember = 'team_member',
  Template = 'template',
  TextTemplate = 'text_template',
  Text = 'text',
  Textarea = 'textarea',
  Textbox = 'textbox',
  ThanksLoading = 'thanks_loading',
  Thanks = 'thanks',
  TimePeriod = 'time_period',
  TimesheetEntry = 'timesheet_entry',
  Timesheet = 'timesheet',
  Timeslot = 'timeslot',
  TitleParty = 'title_party',
  Today = 'today',
  Toggle = 'toggle',
  Topic = 'topic',
  Topic2 = 'topic2',
  TourCheck = 'tour_check',
  Tour = 'tour',
  TrailheadAlt = 'trailhead_alt',
  Trailhead = 'trailhead',
  TransactionUsageEntitlement = 'transaction_usage_entitlement',
  TravelMode = 'travel_mode',
  UnifiedHealthScore = 'unified_health_score',
  Unmatched = 'unmatched',
  UploadedModel = 'uploaded_model',
  UsageEntitlementAccount = 'usage_entitlement_account',
  UsageEntitlementBucket = 'usage_entitlement_bucket',
  UsageEntitlementEntry = 'usage_entitlement_entry',
  UsageRateableSummary = 'usage_rateable_summary',
  UserRole = 'user_role',
  User = 'user',
  Variable = 'variable',
  VariationAttributeSetup = 'variation_attribute_setup',
  VariationProducts = 'variation_products',
  Video = 'video',
  VisitTemplates = 'visit_templates',
  Visits = 'visits',
  VisualforcePage = 'visualforce_page',
  Visualization = 'visualization',
  VoiceCall = 'voice_call',
  VolumeDiscounts = 'volume_discounts',
  Waits = 'waits',
  Walkthroughs = 'walkthroughs',
  WarrantyTerm = 'warranty_term',
  Water = 'water',
  Webcart = 'webcart',
  Whatsapp = 'whatsapp',
  WorkCapacityLimit = 'work_capacity_limit',
  WorkCapacityUsage = 'work_capacity_usage',
  WorkContract = 'work_contract',
  WorkForecast = 'work_forecast',
  WorkOrderItem = 'work_order_item',
  WorkOrder = 'work_order',
  WorkPlanRule = 'work_plan_rule',
  WorkPlanTemplateEntry = 'work_plan_template_entry',
  WorkPlanTemplate = 'work_plan_template',
  WorkPlan = 'work_plan',
  WorkQueue = 'work_queue',
  WorkStepTemplate = 'work_step_template',
  WorkStep = 'work_step',
  WorkSummary = 'work_summary',
  WorkTypeGroup = 'work_type_group',
  WorkType = 'work_type',
  WorkforceEngagement = 'workforce_engagement',
  Workspace = 'workspace',
  YourAccount = 'your_account',
}
